/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:mentor
 */

import * as Types from '../../types/mentor-gql';

import { api } from 'app/apis/mentor-gql-api';
export type MentorDash_CreateMentorMutationVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
  languages?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>
  >;
  bio?: Types.InputMaybe<Types.Scalars['String']['input']>;
  github_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  linkedin_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  avatar_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
  application?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  agreement_version?: Types.InputMaybe<Types.Scalars['String']['input']>;
  phone_number?: Types.InputMaybe<Types.Scalars['String']['input']>;
  timezone?: Types.InputMaybe<Types.Scalars['String']['input']>;
  gov_mentor_agreement_version?: Types.InputMaybe<Types.Scalars['String']['input']>;
  available_hours?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type MentorDash_CreateMentorMutation = {
  __typename?: 'Mutation';
  createMentor?: {
    __typename?: 'Mentor';
    uid: string;
    languages?: Array<string | null> | null;
    bio?: string | null;
    github_url?: string | null;
    linkedin_url?: string | null;
    avatar_url?: string | null;
    application?: any | null;
    agreement_version?: string | null;
    phone_number?: string | null;
    timezone?: string | null;
    gov_mentor_agreement_version?: string | null;
    available_hours?: number | null;
  } | null;
};

export const MentorDash_CreateMentorDocument = `
    mutation MentorDash_CreateMentor($uid: String!, $languages: [String], $bio: String, $github_url: String, $linkedin_url: String, $avatar_url: String, $application: JSON, $agreement_version: String, $phone_number: String, $timezone: String, $gov_mentor_agreement_version: String, $available_hours: Int) {
  createMentor(
    uid: $uid
    languages: $languages
    bio: $bio
    github_url: $github_url
    linkedin_url: $linkedin_url
    avatar_url: $avatar_url
    application: $application
    agreement_version: $agreement_version
    phone_number: $phone_number
    timezone: $timezone
    gov_mentor_agreement_version: $gov_mentor_agreement_version
    available_hours: $available_hours
  ) {
    uid
    languages
    bio
    github_url
    linkedin_url
    avatar_url
    application
    agreement_version
    phone_number
    timezone
    gov_mentor_agreement_version
    available_hours
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_CreateMentor: build.mutation<MentorDash_CreateMentorMutation, MentorDash_CreateMentorMutationVariables>({
      query: (variables) => ({ document: MentorDash_CreateMentorDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
